import './Dialog.scss';
import trumpLogo from '../../assets/trump_avatar.jpg';
import userAvatar from '../../assets/user_avatar.jpg';

interface DialogProps {
  role: string;
  content: string;
  isInterrupted: boolean;
  volume?: number;
}

export function Dialog({ role, content, isInterrupted, volume }: DialogProps) {
  return (
    <div data-component="Dialog">
      {role === 'user' && (
        <div className={`speaker-content speaker-content-user`}>
          <div className="avatar-container">
            <div className="user-avatar">
              <img src={userAvatar} alt="User" />
            </div>
          </div>
          <div>
            {content === "(awaiting transcript)" ? (
              <div className="loading-wave">
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              content
            )}
          </div>
        </div>
      )}

      {role === 'assistant' && (
        <div className={`speaker-content speaker-content-assistant`}>
          <div className="avatar-container">
            <div className="user-avatar">
              {volume !== undefined && <div className="avatar-halo" style={{ transform: `scale(${1 + volume * 0.02})` }} />}
              <img src={trumpLogo} alt="Trump" />
            </div>
            {/* <strong className="avatar-name">
              Donald J. Trump
              <div className="verified-badge-container">
                <img src={verifiedBadge} alt="Verified" className="verified-badge" />
              </div>
            </strong> */}
          </div>
          <div>{content}</div>
          {isInterrupted && (
            <div style={{
              backgroundColor: '#d3d3d375',
              borderRadius: '12px',
              padding: '4px 8px',
              // display: 'inline-block',
              display: 'none',
              fontSize: '0.8em',
              color: 'grey'
            }}>Interrupted</div>
          )}
        </div>
      )}
    </div>
  );
};
